import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Process from "./components/Process";
import BeforeAfter from "./components/BeforeAfter";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <Process />
        <BeforeAfter />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
